const routes = [
  {
    path: "atividades",
    component: () => import("@/views/colaborador/atividades/Atividades.vue"),
    meta: {
      menu: "dashboard",
      title: "Atividades",      
    },
  },
];

export default routes;
